import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../styles/theme';
import Navigation from './Navigation';
import Logo from '../../assets/images/wisdom_sprouts_logo.png';
const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.background};
`;

const Header = styled.header`
  background-color: ${theme.colors.surface};
  box-shadow: ${theme.shadows.sm};
  padding: ${theme.spacing.md};
  position: sticky;
  top: 0;
  z-index: 1000;
  
  @media (max-width: ${theme.breakpoints.sm}) {
    padding: ${theme.spacing.sm};
  }
`;

const Main = styled.main`
  flex: 1;
  padding: ${theme.spacing.xl};
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: ${theme.breakpoints.md}) {
    padding: ${theme.spacing.lg};
  }
  
  @media (max-width: ${theme.breakpoints.sm}) {
    padding: ${theme.spacing.md};
  }
`;

const Footer = styled.footer`
  background-color: ${theme.colors.surface};
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  text-align: center;
  color: ${theme.colors.text.secondary};
  
  @media (max-width: ${theme.breakpoints.sm}) {
    padding: ${theme.spacing.md};
  }
`;

const Layout = ({ children }) => {
  const currentYear = new Date().getFullYear();

  return (
    <LayoutContainer>
      <Header className='p-0'>
        <Navigation />
      </Header>
      <Main>{children}</Main>
      <Footer>
        © {currentYear} Wisdom Sprouts  Portal. All rights reserved.
      </Footer>
    </LayoutContainer>
  );
};

export default Layout; 